module.exports = __webpack_public_path__ + "img/img5.8bad8bc2.png";